import React from 'react';
import type { FormValues, GoalWithIds } from '../../../../../../common/types';
import { useFormContext } from '../../../../../../controllers/form/index.tsx';
import { useGoalCounter } from '../../../../../../controllers/goal-counter';
import { EditableGoalField } from './goal';

type Props = {
	isDraggable?: boolean;
	goals: GoalWithIds;
	setGoals: (arg1: GoalWithIds) => void;
	getFormValues: () => FormValues;
};

export const GoalListView = ({ goals, setGoals, isDraggable, getFormValues }: Props) => {
	const [, { setFormStatusToDirty }] = useFormContext();
	const [, actions] = useGoalCounter();
	const onRemoveGoal = (removedGoalIndex: number) => {
		const goalsAfterRemoval = goals.filter((_, index) => index !== removedGoalIndex);
		setGoals(goalsAfterRemoval);
		setFormStatusToDirty();
		actions.decrementGoalCounter();
	};

	// @ts-expect-error - TS7006 - Parameter 'updatedGoal' implicitly has an 'any' type.
	const onSaveGoal = (removedGoalIndex: number, updatedGoal) => {
		const modifiedGoals = [...goals];
		const [goalToBeUpdated] = modifiedGoals.splice(removedGoalIndex, 1);
		modifiedGoals.splice(removedGoalIndex, 0, {
			...goalToBeUpdated,
			...updatedGoal,
		});
		setGoals(modifiedGoals);
		setFormStatusToDirty();
	};

	return (
		<>
			{goals.map((goal, index) => (
				<EditableGoalField
					key={goal.id}
					goal={goal}
					index={index}
					onRemoveGoal={() => onRemoveGoal(index)}
					onSaveGoal={(modifiedGoal) => onSaveGoal(index, modifiedGoal)}
					isDraggable={isDraggable}
					getFormValues={getFormValues}
				/>
			))}
		</>
	);
};
